module.exports = __webpack_public_path__ + "static/media/icefields-11.3b83fee5.jpg";